import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import LuxuryBrands from "./component";
import { setData, setStep } from "../lead-form/actions";

const mapStateToProps = ({
    brands: { elite }
}) => {
    return {
        elite
    };
};
const mapDispatchToProps = (dispatch) => bindActionCreators({
    setDataConnect: setData,
    setStepConnect: setStep
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LuxuryBrands));
